import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad2d3198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Master Invoice", -1))
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Semua Tipe Tagihan", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "col-lg-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Semua Jenis Invoice", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "SEKALI" }, "SEKALI", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "BERULANG" }, "BERULANG", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Tipe Tagihan"),
    /*#__PURE__*/_createElementVNode("th", null, "Nama Tagihan"),
    /*#__PURE__*/_createElementVNode("th", null, "Sekolah"),
    /*#__PURE__*/_createElementVNode("th", null, "Jenis Invoice"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_18 = { class: "d-flex gap-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "row mt-5 mb-5" }
const _hoisted_22 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_23 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_24 = ["label", "value"]
const _hoisted_25 = { class: "p-3" }
const _hoisted_26 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_27 = { class: "pagination" }
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "is-full-page": true,
      color: "#007BFF",
      "background-color": "#A3A3A3",
      opacity: "0.5"
    }, null, 8, ["active"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/master-invoices/add')))
          }, " Add Master Invoice ")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.invoicesettingId) = $event)),
              class: "form-select form-select-sm"
            }, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceSettingList, (item, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item._id
                }, _toDisplayString(item.title), 9, _hoisted_9))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.invoicesettingId]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.schoolId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schoolId) = $event)),
              placeholder: "Pilih Sekolah",
              mode: "single",
              options: _ctx.ListSchool,
              searchable: true,
              label: "name",
              "track-by": "name",
              "value-prop": "id",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihSekolah($event))),
              onSearchChange: _ctx.cari,
              loading: _ctx.loadingComboSchool
            }, null, 8, ["modelValue", "options", "onSearchChange", "loading"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.invoiceType) = $event)),
              class: "form-select form-select-sm"
            }, _hoisted_15, 512), [
              [_vModelSelect, _ctx.invoiceType]
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: invoice.id
              }, [
                _createElementVNode("td", null, _toDisplayString((index as number) + 1), 1),
                _createElementVNode("td", null, _toDisplayString(invoice.invoiceSettingName), 1),
                _createElementVNode("td", null, _toDisplayString(invoice.title), 1),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoice.schoolNames, (i, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "badge badge-light-primary fs-7 fw-bold",
                      key: index
                    }, _toDisplayString(i), 1))
                  }), 128))
                ]),
                _createElementVNode("td", null, _toDisplayString(invoice.invoiceSetting.invoiceType), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      class: "btn btn-warning",
                      onClick: ($event: any) => (
                    _ctx.$router.push(
                      '/superadmin/master-invoices/edit/' + invoice._id,
                    )
                  )
                    }, " Edit ", 8, _hoisted_19),
                    _createElementVNode("button", {
                      class: "btn btn-danger",
                      onClick: ($event: any) => (_ctx.deleteInvoice(invoice._id))
                    }, " Delete ", 8, _hoisted_20)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item.toString(),
                      value: item
                    }, null, 8, _hoisted_24))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(1, _ctx.paging.totalPages), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["page-item", { active: _ctx.paging.page + 1 === item }]),
                  key: item
                }, [
                  (Math.abs(item - _ctx.paging.page) <= 2)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "page-link",
                        onClick: ($event: any) => (_ctx.changePage(item))
                      }, _toDisplayString(item), 9, _hoisted_28))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}